/**
 * pulse — Layer 1 market-pulse strip backed by `/api/v2/home/pulse`.
 *
 * Cheap reactive store + manual/auto refresh helpers. Auto-refresh interval
 * defaults to 60s per PI-244; the backend caches per-tile for 30s so each
 * fan-out is cheap regardless of how many users are online.
 */
import PulseRepository from '@/repositories/PulseRepository';
import { computed, ref } from 'vue';

const tiles = ref([]);
const refreshedAt = ref(null);
const role = ref('none');
const isLoading = ref(false);

export async function loadPulse(options) {
  isLoading.value = true;
  try {
    const response = await PulseRepository.getPulse(options);
    if (response?.data) {
      tiles.value = response.data.items || [];
      refreshedAt.value = response.data.refreshed_at ? new Date(response.data.refreshed_at) : new Date();
      role.value = response.data.role || 'none';
    }
  } catch (error) {
    tiles.value = [];
    refreshedAt.value = null;
  } finally {
    isLoading.value = false;
  }
  return tiles.value;
}

export function usePulse() {
  return {
    tiles: computed(() => tiles.value),
    refreshedAt: computed(() => refreshedAt.value),
    role: computed(() => role.value),
    isLoading: computed(() => isLoading.value),
    loadPulse,
  };
}

export default { loadPulse, usePulse };
